module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {

	fox.registerWidget('SitePage_Tips', {

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					tips: {
						widget: 'Tips_Form',
						autoApply: true,
						container: '.tips-block',
						template: 'sitepage_tips_form',
						widgets: {
							form: {
								formContainer: '.tips-block',
								submit: {
									target: '#tipsSubmit',
									event: 'click'
								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Site_Page')

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/sitepage/tips.js
// module id = 139
// module chunks = 4